module.exports = new __parcel__URL__("tetris.ab45301f.jpg").toString();